import { render, staticRenderFns } from "./RbvLoading.vue?vue&type=template&id=618ecb74&"
import script from "./RbvLoading.vue?vue&type=script&lang=js&"
export * from "./RbvLoading.vue?vue&type=script&lang=js&"
import style0 from "./RbvLoading.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports